import * as React from "react";
import Box from "@mui/material/Box";
import Stepper from "@mui/material/Stepper";
import Step from "@mui/material/Step";
import StepButton from "@mui/material/StepButton";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import { useDispatch, useSelector } from "react-redux";
import {
  allStepsCompleted,
  handleReset,
} from "../../redux/slices/addNewContentStepsSlice";
import { steps } from "../../constants";
import { StepLabel } from "@mui/material";
import { useParams } from "react-router-dom";
import { generateClient } from "aws-amplify/api";
import { getContent, listCategories } from "../../graphql/queries";
import CircularProgress from "@mui/material/CircularProgress";
import { setAgreementDetails } from "../../redux/slices/agreementFormSlice";
import { toast } from "react-toastify";
import { handleCompleteStep } from "../../redux/slices/addNewContentStepsSlice";
import { setContentForm } from "../../redux/slices/contentSlice/contentForm/contentForm";
import { setCategories } from "../../redux/slices/contentSlice/contentForm/contentForm";
import { handleFilePicked } from "../../redux/slices/contentSlice/onedriveContent/onedriveContent";
import { handleManifestPreview } from "../../redux/slices/manifestPreviewSlice";
import NavigationWarningModal from "../NavigationWarningModal";

export default function EditContentStepper() {
  const params = useParams();
  const { agreementId, contentId } = params;
  const activeStep = useSelector(
    (state) => state.addNewContentSteps.activeStep
  );
  const completed = useSelector((state) => state.addNewContentSteps.completed);
  const dispatch = useDispatch();
  const [isLoading, setLoading] = React.useState(true);
  const [error, setError] = React.useState("");

  const renderStepContent = (activeStep) => {
    const renderStep = steps.find(
      (step, stepIndex) => stepIndex === activeStep
    );

    if (renderStep) {
      return renderStep?.component;
    } else {
      return <Typography>Not Found 404</Typography>;
    }
  };
  const client = generateClient();

  const fetchContentCategories = async (contentType) => {
    try {
      const response = await client.graphql({
        query: listCategories,
        variables: {
          filter: {
            type: {
              eq: contentType,
            },
          },
        },
      });
      return response.data.listCategories.items;
    } catch (error) {
      console.log(error.message);
    }
  };

  React.useEffect(() => {
    const fetchContent = async () => {
      try {
        const response = await client.graphql({
          query: getContent,
          variables: { id: contentId, agreementId },
        });
        dispatch(setAgreementDetails(response.data.getContent.agreement));
        dispatch(setContentForm(response.data.getContent));
        const categoriesList = await fetchContentCategories(
          response.data.getContent.type
        );
        dispatch(setCategories(categoriesList));
        dispatch(handleCompleteStep(0));
        dispatch(
          handleManifestPreview({
            contentSource: "s3",
          })
        );
        dispatch(handleFilePicked(true));
        // setContentData(response.data.getContent);
        // formik.setValues(response.data.getContent);
      } catch (error) {
        console.error("Error fetching content:", error);
        toast.error("Error fetching content details");
        setError("Error fetching content details");
      } finally {
        setLoading(false);
      }
    };

    fetchContent();
  }, []);

  if (error) return "An error has occurred: ";

  return (
    <>
      <NavigationWarningModal />
      {isLoading ? (
        <Box
          width={"100%"}
          height={"100%"}
          display={"flex"}
          justifyContent={"center"}
          alignItems={"center"}
        >
          <CircularProgress />
        </Box>
      ) : (
        <Box sx={{ width: "100%" }}>
          <Stepper nonLinear activeStep={activeStep} alternativeLabel>
            {steps.map((label, index) => (
              <Step key={index} completed={completed[index]}>
                <StepButton color="secondary" disabled>
                  <StepLabel>{label?.label}</StepLabel>
                </StepButton>
              </Step>
            ))}
          </Stepper>
          <div>
            {allStepsCompleted(steps) ? (
              <React.Fragment>
                <Typography sx={{ mt: 2, mb: 1 }}>
                  All steps completed - you&apos;re finished
                </Typography>
                <Box sx={{ display: "flex", flexDirection: "row", pt: 2 }}>
                  <Box sx={{ flex: "1 1 auto" }} />
                  <Button onClick={() => dispatch(handleReset())}>Reset</Button>
                </Box>
              </React.Fragment>
            ) : (
              <React.Fragment>{renderStepContent(activeStep)}</React.Fragment>
            )}
          </div>
        </Box>
      )}
    </>
  );
}
